import { Component, createRef } from 'react'
import PropTypes from 'prop-types'
import { noop } from 'lodash'

export default class ElementPan extends Component {
  static propTypes = {
    scrollLeft: PropTypes.number, // note: This is the html element scrollLeft property
    onScroll: PropTypes.func,
    className: PropTypes.string,
    tag: PropTypes.string,
  }

  static defaultProps = {
    scrollLeft: 0,
    onScroll: noop,
    className: '',
    tag: 'ul',
  }

  constructor(props) {
    super(props)
    this.$elementRef = createRef()
  }

  componentDidMount() {
    this.transferScrollLeft()
  }

  componentDidUpdate() {
    this.transferScrollLeft()
  }

  // Note: Updates the css property, not to be confused with a boolean or anything
  transferScrollLeft() {
    const { scrollLeft } = this.props
    this.$elementRef.current.scrollLeft = scrollLeft
  }

  handleScroll = event => {
    const { onScroll } = this.props
    onScroll(event.target.scrollLeft)
  }

  render() {
    const { className, tag: Tag } = this.props
    return (
      <Tag ref={this.$elementRef} className={className} onScroll={this.handleScroll}>
        {this.props.children}
      </Tag>
    )
  }
}
